import type { WorkflowExecution } from '@shared/types/executions';

export const isViewerProcessExecution = (execution: WorkflowExecution) =>
  execution.name !== 'QCT_QUERY';

export const QC_STATUS_MESSAGES = {
  QC_EXPORT: {
    COMPLETED:
      'DICOM file has been exported successfully. You can re-download it anytime from Process history.',
    FAILED:
      'Something went wrong during DICOM export. Please try again.',
  },
  QC_IMPORT: {
    COMPLETED:
      'Segmentation file has been imported successfully. Please reload the page to view the imported segmentation.',
    FAILED:
      'Something went wrong during segmentation import. Please try again.',
  },
} as const;
